export default {
      id: "color_bacteria_scientist-usage",
      viewBox: "0 0 120 149",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_scientist",
      toString: function () {
        return this.url;
      }
    }